import {useLocale} from "../context/LocaleContext";
import {publicPageCopy} from "../context/publicPageCopy";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowLeft, Sparkles } from "lucide-react";

export default function Placeholder({ title, paragraphs = [] }) {
 const {t: translate, locale: currentLocale}=useLocale();
 const displayedParagraphs=publicPageCopy[currentLocale]?.[title]||paragraphs;

  return (
    <div className="flex min-h-[calc(100vh-160px)] items-center justify-center px-6 py-16">
      <div className="sy-fade-in max-w-lg text-center">
        <div className="mx-auto mb-6 flex justify-center">
          <Link to="/" aria-label={translate("Ana Sayfa")}>
            <img
              src="/sayyadi-logo-dark.png"
              alt="Sayyâdî"
              className="w-64 select-none transition-opacity hover:opacity-85"
              draggable={false}
            />
          </Link>
        </div>
        <h1 className="font-display text-4xl font-semibold sy-gold-text sm:text-5xl">
          {translate(title)}
        </h1>
        <div
          className="mx-auto mt-5 inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-sm"
          style={{ borderColor: "var(--sy-border)", color: "var(--sy-text-dim)" }}
        >
          <Sparkles size={14} style={{ color: "var(--sy-gold)" }} />
          {paragraphs.length ? translate("İlim · Sohbet · İrfan") : translate("Bu bölüm hazırlanıyor")}
        </div>
        {paragraphs.length ? displayedParagraphs.map((paragraph, index) => (
          <p key={index} lang={publicPageCopy[currentLocale]?.[title]?currentLocale:translate(paragraph)===paragraph?"tr":currentLocale} dir={publicPageCopy[currentLocale]?.[title]?undefined:translate(paragraph)===paragraph?"ltr":undefined} data-testid="public-page-paragraph" className="mt-5 text-base leading-relaxed" style={{ color: "var(--sy-text-dim)" }}>
            {translate(paragraph)}
          </p>
        )) : (
          <p className="mt-5 text-base leading-relaxed" style={{ color: "var(--sy-text-dim)" }}>
            “{translate(title)}{translate("” sayfası yakında burada olacak. Sayyâdî Dergâhı'nın dijital hazinesi, kaynaklı ve kanıtlı içeriklerle siz dervişlere açılıyor.")}{" "}</p>
        )}
        <Link to="/" className="mt-8 inline-block">
          <Button
            className="gap-2 font-semibold border"
            style={{ background: "transparent", color: "var(--sy-gold-bright)", borderColor: "rgba(201,167,101,0.4)" }}
          >
            <ArrowLeft size={16} />{" "}{translate("Ana Sayfaya Dön")}{" "}</Button>
        </Link>
      </div>
    </div>
  );
}
